import { onMounted, onUnmounted } from "vue";

export function useClickOutside(elementRef, callback) {
  const handleClick = (event) => {
    if (elementRef.value && !elementRef.value.contains(event.target)) {
      callback(event);
    }
  };

  onMounted(() => {
    document.addEventListener("mousedown", handleClick);
  });

  onUnmounted(() => {
    document.removeEventListener("mousedown", handleClick);
  });
}
